
  <div class="row">

    <div class="col-md-2">

    </div>





      <div class="col-md-8" *ngIf="ban">

        <div style="text-align: center">

          <h1> Customer satisfaction survey </h1>


          <br>

          <img [src] ="img">

          <br>

          <br>

          <h3> Code:  <b> {{ order }} </b> </h3>

          <h3> Driver: <b>  {{ firstname }} {{ lastname }} </b>  </h3>

          <h3> Date:  <b> {{ datedelivery}} </b>  </h3>




        </div>






        <div class="row" style="text-align: center">

          <br>

          <star-rating value="0" totalstars="5" checkedcolor="#2980b9" uncheckedcolor="#dcdde1" size="60px" readonly="false" (rate)="onRate($event)"></star-rating>

          <!--
          <div id="surveyElement"></div>
           -->
          <br>
          <label> Comments: </label>
           <textarea [(ngModel)]="description" class="form-control" rows="10">

           </textarea>

           <br>

           <button class="btn btn-primary" [disabled]="ratingStar == 0" (click)="sendPoll()"> Calificate </button>
        </div>


      </div>

      <div class="col-md-8" *ngIf="recall">
          <div style="text-align: center">

          <h1> Customer satisfaction survey </h1>

          <h3>Thanks for answer</h3>

          <a href="https://4dev.armandozabala.com" class="btn btn-success"> Visit website </a>

          </div>
      </div>

      <div class="col-md-2">

      </div>

  </div>



<!--

-->
